import { PageApi } from 'api/PageApi';
import { backendApiClient } from 'container/backendApiClient';

export const pageApi: PageApi = new PageApi(backendApiClient);
